import { Form, Modal } from "antd";
import React from "react";
import { CreateDropCodeDto } from "../../../api";
import { dropCodesColumns } from "../form/columns";

interface DropCodeFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateDropCode: (values: CreateDropCodeDto) => void;
}

export const DropCodeForm: React.FC<DropCodeFormProps> = ({ visible, setVisible, onCreateDropCode }) => {
  const [form] = Form.useForm<CreateDropCodeDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateDropCode}>
        {dropCodesColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
          {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
